<div class="drawer-container">
  <div class="drawer-content">
    <div class="product-info-section" *ngIf="ProductData && WarehouseData">
      <div class="product-info">
        <span class="product-code">{{ ProductData.code }}</span>
        <span class="product-name">{{ ProductData.name || (ProductData.brand + ' - ' + ProductData.model) }}</span>
        <span class="store-info">{{ WarehouseData.name }} - {{ 'pages.stock.add_stock.incoming_quantity' | translate }}:
          {{ ProductData.quantity }}</span>
      </div>
    </div>

    <div *ngIf="isLoading" class="loading-container">
      <div class="loading-spinner"></div>
      <p>{{ 'pages.stock.add_stock.processing' | translate }}</p>
    </div>

    <div *ngIf="!isLoading && (!ProductData || !WarehouseData)" class="error-container">
      <div class="error-content">
        <h3>{{ 'pages.stock.add_stock.no_data_title' | translate }}</h3>
        <p>{{ 'pages.stock.add_stock.no_data_message' | translate }}</p>
        <button type="button" class="btn btn-secondary" (click)="onCancel()">
          {{ 'common.close' | translate }}
        </button>
      </div>
    </div>




    <div *ngIf="!isLoading && ProductData && WarehouseData" class="options-container">

      <div class="mode-selector">
        <button type="button" class="mode-btn" *ngFor="let option of AssignmentModeOptions"
          [class.active]="currentMode === option" (click)="setAssignmentMode(option)">
          {{ 'pages.stock.add_stock.' + option | translate }}
        </button>
      </div>

      <form *ngIf="form" [formGroup]="form" class="form-container">

        <div class="form-field form-field-full">
          <label for="dot">{{ 'addStock.dotDate' | translate }} <span class="required-mark">*</span></label>
          <input type="text" id="dot" [formControl]="form.controls.dot" class="form-control" maxlength="4"
            placeholder="2324">
        </div>

        <div class="form-field form-field-full">
          <label for="cost">{{ 'pages.stock.add_stock.product_cost' | translate }}: </label>
          <input type="number" [formControl]="form.controls.cost" [placeholder]="'0.00'" class="form-control">
        </div>

        <div class="form-field form-field-full">
          <label for="location-text">{{ 'pages.stock.add_stock.locations' | translate }}: </label>
          <input type="text" [formControl]="form.controls.locationText"
            [placeholder]="('pages.stock.add_stock.locations' | translate) + '...'" class="form-control"
            (keyup.enter)="addLocation()">

          <button class="option-input-click" *ngIf="form.controls.locationText.value"
            (click)="addLocation()">{{form.controls.locationText.value}}</button>
          <div class="locations-tag-container" *ngIf="form.controls.locations.value.length">
            <button class="locations-tag" *ngFor="let tag of form.controls.locations.value; let i = index"
              (click)="removeLocations(i)">
              {{tag}} X
            </button>
          </div>
        </div>

      </form>

      <div *ngIf="currentMode === AssignmentModeOption.AGENDA" class="assignment-option">
        <!--  -->
        <div class="agenda-selection">
          <h3>{{ 'pages.stock.add_stock.available_agendas' | translate }}</h3>

          <div *ngIf="AvailableAgendas.length === 0" class="no-agendas">
            <p>{{ 'pages.stock.add_stock.no_available_agendas' | translate }}</p>
          </div>

          <div *ngIf="AvailableAgendas.length > 0" class="agenda-list">
            <button *ngFor="let agenda of AvailableAgendas" class="agenda-item"
              [class.selected]="form?.controls?.agendaId?.value === agenda.id" (click)="toggleAgendaSelection(agenda)">
              <div class="agenda-info">
                <div class="client-name">{{ agenda.clientFullName }}</div>
                <div class="service-type">{{ agenda.serviceType }}</div>
                <div class="scheduled-date">{{ agenda.scheduledDate | localizedDate:'datetime' }}</div>
                <div class="status">{{ agenda.status }}</div>
              </div>
              <div class="selection-indicator">
                <i *ngIf="form?.controls?.agendaId?.value === agenda.id" class="icon-check"></i>
              </div>
            </button>
          </div>

          <div *ngIf="SelectedAgendas.length > 0" class="selected-summary">
            <p>{{ 'pages.stock.add_stock.selected_agendas_count' | translate: {count: SelectedAgendas.length} }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="drawer-footer">
      <button type="button" class="btn btn-secondary" (click)="onCancel()" [disabled]="isLoading">
        {{ 'common.cancel' | translate }}
      </button>
      <button type="button" class="btn btn-primary" (click)="onSubmit()" [class.disabled]="isLoading || form?.invalid">
        <span *ngIf="isLoading" class="loading-spinner"></span>
        <span *ngIf="!isLoading && currentMode === AssignmentModeOption.WAREHOUSE">{{
          'pages.stock.add_stock.add_to_warehouse_btn' |
          translate }}</span>
        <span *ngIf="!isLoading && currentMode === AssignmentModeOption.AGENDA">{{
          'pages.stock.add_stock.reserve_for_agenda_btn' |
          translate }}</span>
        <span *ngIf="isLoading">{{ 'common.processing' | translate }}...</span>
      </button>
    </div>

  </div>
</div>
